import { InjectedFormProps, reduxForm } from 'redux-form';
import { FormError } from 'src/components/redux-form/FormError';
import React from 'react';
import { maxLength, required, Validators } from 'src/components/redux-form/utils/validators';
import classNames from 'classnames';
import { FieldInput } from 'src/components/redux-form/fields/FieldInput';
import { Link } from 'react-router-dom';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import styles from './assets/invoice-form.module.scss';
import { faSave, faBan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { asyncPersistInvoice } from 'src/store/actions/invoice-actions';
import { Dispatch } from 'redux';
import { toast } from 'react-toastify';
import { DropZoneField } from 'src/components/DropZoneField';

export interface InvoiceFormData {
    id: string | number;
    name?: string;
    status?: number;
    statusDocusign?: number | string;
    isReadyToSent?: boolean | number;
    filters?: any;
    RequestSent?: boolean | number;
    reason?: string;
    note?: string;
}

interface InvoiceFormProps {
    files: any;
    setFiles: (it: []) => void;
    removeFile: (it: any) => void;
}

type InjectedProps = InjectedFormProps<InvoiceFormData, InvoiceFormProps>;

const validators: Validators<InvoiceFormData> = {
    name: [required({ message: 'Name is required.' }), maxLength({ max: 255 })],
};

const InvoiceForm: React.FunctionComponent<InjectedProps & InvoiceFormProps> = ({
    handleSubmit,
    error,
    dirty,
    files,
    setFiles,
    removeFile,
    submitting,
    initialValues,
}: InjectedProps & InvoiceFormProps) => {
    const isNew = !initialValues || !initialValues.id;

    return (
        <form onSubmit={handleSubmit} className={classNames(styles.form)}>
            <FormError error={error} />
            <FieldInput
                name="id"
                type="hidden"
                wrapperConfig={{
                    classes: {
                        inputWrapper: 'm-0',
                    },
                }}
            />
            <FieldInput
                name="Name"
                type="text"
                validate={validators.name}
                wrapperConfig={{
                    label: 'Name *',
                }}
            />

            <DropZoneField files={files} setFiles={setFiles} removeFile={(id: string | number) => removeFile(id)} />
            <div className={classNames(styles.actions)}>
                <button type="submit" className={classNames('btn', 'btn-success')} disabled={!dirty || submitting}>
                    <FontAwesomeIcon icon={faSave} /> {isNew ? 'Create' : 'Update'}
                </button>
                <Link className={classNames('btn', 'btn-danger')} to={Router.generate(routes.INVOICES_LIST)}>
                    <FontAwesomeIcon icon={faBan} /> Cancel
                </Link>
            </div>
        </form>
    );
};

export default reduxForm<InvoiceFormData, InvoiceFormProps>({
    form: 'invoice-form',
    onSubmit: async (data: InvoiceFormData, dispatch: Dispatch<any>, props: InvoiceFormProps) => {
        await asyncPersistInvoice(data, props.files, dispatch);
    },
    onSubmitSuccess() {
        toast.success('add invoice success.');
    },

    onSubmitFail(errors: { _error: string }) {
        if (errors._error) {
            toast.error(errors._error);
        }
    },
})(InvoiceForm);
